import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "axios";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";

import titulo from "../../asses/img/titulo.png"; // logo superior
import background from "../../asses/img/background.png"; // ilustración inferior

// Opciones
const tipoOptions = [
  { value: "total", label: "Eliminación total de cuenta" },
  { value: "parcial", label: "Eliminación parcial (datos específicos)" },
  { value: "revocacion", label: "Revocación de autorización de tratamiento" },
];

const datosOptions = [
  { value: "todos", label: "Todos los datos" },
  { value: "numeroDocumento", label: "Número de documento" },
  { value: "numeroCelular", label: "Número de celular" },
];


const styles = {
  page: {
    position: 'relative',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
  },
  card: {
    width: '100%',
    maxWidth: 500, // más angosto como el diseño
    margin: '24px auto',
    padding: 20,
    background: '#fff',
    borderRadius: 22,
    border: '1px solid #e7ebf2',
    boxShadow: '0 10px 30px rgba(27,78,163,.08)',
    position: 'relative',
    zIndex: 1,
  },
  logoWrap: { display: 'grid', placeItems: 'center', marginBottom: 6 },
  logo: { maxWidth: 180, height: 'auto' },
  title: {
    textAlign: 'center',
    marginTop: 6,
    marginBottom: 8,
    fontWeight: 600,
  },
  note: { color: '#7a7a7a', fontSize: 12, marginBottom: 10 },
  bg: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: 'min(38vh, 240px)',
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom',
    backgroundSize: 'cover',
    opacity: 0.9,
    pointerEvents: 'none',
    zIndex: 0,
  },
  button: {
    backgroundColor: '#8bd63e',
    borderColor: '#8bd63e',
    color: '#063b00',
    fontWeight: 700,
    borderRadius: 999,
    height: 44,
    width: '100%', 
  },
};

// Estilos de react-select para que luzca como los inputs del mock
const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 44,
    height: 44,
    backgroundColor: "#f6f8fb",
    borderColor: state.isFocused ? "#cdd7ee" : "#e7ebf2",
    borderRadius: 12,
    boxShadow: state.isFocused ? "0 0 0 4px rgba(99,171,255,.15)" : "none",
    ':hover': { borderColor: state.isFocused ? "#cdd7ee" : "#e7ebf2" },
  }),
  valueContainer: (base) => ({ ...base, height: 44, padding: '2px 12px' }),
  input: (base) => ({ ...base, margin: 0 }),
  indicatorsContainer: (base) => ({ ...base, height: 44 }),
  placeholder: (base) => ({ ...base, color: '#8a8f98' }),
  menu: (base) => ({ ...base, borderRadius: 12, overflow: 'hidden' }),
};

/**
 * EliminarCuentaPage
 * -------------------
 * Ruta accesible en "/eliminar-cuenta". Mantén esta página sin enlaces en el menú
 * para que quede "oculta" pero navegable por URL.
 */
const EliminarCuentaPage = () => {
  const [loading, setLoading] = useState(false);

  const { control, register, handleSubmit, formState: { errors }, reset, watch } = useForm({
    defaultValues: {
      tipo: null,
      datosEliminar: null,
      datos: "",
      documento: "",
      email: "",
      razon: "",
      acepto: false,
    },
  });

  const getCurrentPath = () => {
    // Soporta HashRouter (#/eliminar-cuenta) y BrowserRouter
    const hash = window.location.hash?.replace(/^#/, '') || '';
    const rawPath = hash || window.location.pathname || '/';
    // normaliza: minúsculas, sin query/fragmento, quita slashes finales
    return rawPath.toLowerCase().split('?')[0].replace(/\/+$/, '');
  };

  const onSubmit = async (values) => {
  const path = getCurrentPath();

  // En producción puedes exigir que termine en /eliminar-cuenta
  const REQUIRE_CHECK = process.env.NODE_ENV === 'production';

  if (REQUIRE_CHECK && !path.endsWith('/eliminar-cuenta')) {
    toast.error('Ruta inválida.');
    return;
  }

    const payload = {
      tipo: values.tipo?.value || "",
      datos_seleccion: values.datosEliminar?.value || "",
      datos: values.datos?.trim(),
      documento: values.documento?.trim(),
      email: values.email?.trim(),
      razon: values.razon?.trim(),
      fecha: new Date().toISOString(),
    };

    try {
      setLoading(true);
      //Reemplaza por endpoint real
      // await axios.post(`${URL_SERVICIO}/privacy/delete`, payload);
      await new Promise((r) => setTimeout(r, 700));
      toast.success("Solicitud enviada ✅");
      reset();
    } catch (err) {
      console.error(err);
      toast.error("No se pudo enviar la solicitud, inténtalo más tarde");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // analytic.logEvent('page_view', { page: 'Eliminar Cuenta' });
  }, []);

  // Helper to check if all required fields are filled
  const allFieldsFilled = () => {
    const values = watch();
    return (
      values.tipo &&
      values.datosEliminar &&
      values.documento &&
      values.email &&
      values.razon &&
      values.acepto
    );
  };

  return (
    <div style={styles.page}>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={6}>
            <div style={styles.card}>
              <div style={styles.logoWrap}>
                <img src={titulo} style={styles.logo} alt="goparking" />
              </div>
              <br></br>
              <h6 style={{ ...styles.title, color: '#668F0F' }}>
                Solicitud de eliminación de datos
              </h6>
              <p style={styles.note}>
                Nota: la eliminación de datos es irreversible, asegúrate de
                estar seguro de querer eliminar tus datos.
              </p>

              <Form onSubmit={handleSubmit(onSubmit)}>
                {/* 1. Tipo de eliminación */}
                <Form.Group className="mb-2">
                  <Controller
                    name="tipo"
                    control={control}
                    rules={{ required: 'Tipo de eliminación es obligatorio' }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={tipoOptions}
                        placeholder="Tipo de eliminación*"
                        styles={selectStyles}
                      />
                    )}
                  />
                  {errors.tipo && (
                    <Form.Text className="error text-danger">
                      {errors.tipo.message}
                    </Form.Text>
                  )}
                </Form.Group>

                {/* 2. Datos a eliminar (select) */}
                <Form.Group className="mb-2">
                  <Controller
                    name="datosEliminar"
                    control={control}
                    rules={{ required: 'Selecciona los datos a eliminar' }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={datosOptions}
                        placeholder="Datos a eliminar*"
                        styles={selectStyles}
                      />
                    )}
                  />
                  {errors.datosEliminar && (
                    <Form.Text className="error text-danger">
                      {errors.datosEliminar.message}
                    </Form.Text>
                  )}
                </Form.Group>

                {/* 3. Documento */}
                <Form.Group className="mb-2">
                  <Form.Control
                    type="text"
                    inputMode="numeric"
                    placeholder="Número de documento*"
                    style={{
                      height: 44,
                      background: '#f6f8fb',
                      borderColor: '#e7ebf2',
                      borderRadius: 12,
                    }}
                    {...register('documento', {
                      required: 'Ingresa tu documento',
                      pattern: {
                        value: /^[0-9]{4,15}$/g,
                        message: 'Solo números (4 a 15)',
                      },
                    })}
                  />
                  {errors.documento && (
                    <Form.Text className="error text-danger">
                      {errors.documento.message}
                    </Form.Text>
                  )}
                </Form.Group>

                {/* 4. Email */}
                <Form.Group className="mb-2">
                  <Form.Control
                    type="email"
                    placeholder="Correo electrónico*"
                    style={{
                      height: 44,
                      background: '#f6f8fb',
                      borderColor: '#e7ebf2',
                      borderRadius: 12,
                    }}
                    {...register('email', {
                      required: 'El email es obligatorio',
                      pattern: {
                        value: /.+@.+\..+/,
                        message: 'Correo no válido',
                      },
                    })}
                  />
                  {errors.email && (
                    <Form.Text className="error text-danger">
                      {errors.email.message}
                    </Form.Text>
                  )}
                </Form.Group>

                {/* 5. Razón */}
                <Form.Group className="mb-2">
                  <Form.Control
                    as="textarea"
                    rows={5}
                    placeholder="Cuéntanos la razón para eliminar tus datos *"
                    style={{
                      background: '#f6f8fb',
                      borderColor: '#e7ebf2',
                      borderRadius: 12,
                    }}
                    {...register('razon', {
                      required: 'Este campo es obligatorio',
                    })}
                  />
                  {errors.razon && (
                    <Form.Text className="error text-danger">
                      {errors.razon.message}
                    </Form.Text>
                  )}
                </Form.Group>

                {/* 6. Aceptación políticas */}
                <Form.Group className="mb-3" controlId="checkAcepto">
                  <Form.Check
                    type="checkbox"
                    label={
                      <>
                        Acepto las{' '}
                        <Link to="/Politica-TratamientoDatos" target="_blank">
                          políticas de tratamiento de datos
                        </Link>
                      </>
                    }
                    {...register('acepto', {
                      required: 'Debes aceptar nuestras políticas',
                    })}
                  />
                  {errors.acepto && (
                    <Form.Text className="error text-danger">
                      {errors.acepto.message}
                    </Form.Text>
                  )}
                </Form.Group>

                {/* Botón full width redondeado */}
                <div className="d-grid">
                  <Button
                    type="submit"
                    style={styles.button}
                    disabled={loading || !allFieldsFilled()}
                  >
                    {loading ? 'Enviando…' : 'Enviar'}
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>

      <div style={styles.bg} />
    </div>
  );
};

export default EliminarCuentaPage;
